import React from 'react';
import FeesModal from '../feesModal/FeesModal';
import { useGetFeesQuery } from 'lib/services/fees';

interface ReplacementCardFeeModalProps {
    handleSubmit: () => void;
    closeModal: () => void;
}

const ReplacementCardFeeModal: React.FC<ReplacementCardFeeModalProps> = ({
    handleSubmit,
    closeModal,
}) => {
    const { data, isFetching } = useGetFeesQuery();

    if (isFetching) return null;

    return (
        <FeesModal
            action="Ordering a replacement card"
            fee={data?.replacementCard}
            handleSubmit={handleSubmit}
            closeModal={closeModal}
        />
    );
};

export default ReplacementCardFeeModal;
